import {CrudService} from '@ngx-ivengi/crud';
import {Price} from './price.model';
import {Injectable} from '@angular/core';

@Injectable()
export class PriceService extends CrudService<Price> {
  public entityType = Price;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/price/price.service.ts